var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Checkbox = function (_a) {
    var label = _a.label, name = _a.name, value = _a.value, onChange = _a.onChange, checked = _a.checked;
    return (_jsxs("div", __assign({ className: "flex min-w-0 items-center" }, { children: [_jsx("input", { id: "".concat(name, "-").concat(value), type: "checkbox", value: value, name: name, checked: checked, className: "w-4 h-4 shrink-0 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 ", onChange: onChange }), _jsx("label", __assign({ htmlFor: "".concat(name, "-").concat(value), className: "ms-2 min-w-0 flex-1 text-sm font-medium" }, { children: label }))] })));
};
export default Checkbox;
